
import React, { FC } from 'react';
import { X } from 'react-bootstrap-icons';
import { CustomButtonProptypes, GenericButton } from '.';

export const CancelButton: FC<CustomButtonProptypes> = ({
  // id = 'cancel-button',
  color = 'grey',
  fontSize = '1rem',
  tooltip= "Cancel",
  ...props
}) => {
  return <GenericButton
    // id={id}
    color={color}
    tooltip={tooltip}
    {...props}
  >
    <X color={color} fontSize={fontSize} />
  </GenericButton>
}
